import React, { useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postEmployes } from '../../../../MyApi/sb/employes'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddEmploy from '../../../../Components/sb/employ/employStore/AddEmploy'

   

const EmployesStore = () => {
const [name_ar ,setNameAr]= useState("")
const [name_en ,setNameEn]= useState("")
const [mobile, setMobile] =useState("")
const [nation_id,setNationId]=useState("")
const [email,setEmail ] =useState("")
const [password ,setPassword] =useState("")
const [sb_country_id, setSbCountryId] =useState("")
const [sb_city_id, setSbCityId] = useState("")
const [sb_branch_id, setSbBranchId]=useState("")
const [sb_department_id ,setSbDepartmentId] =useState("")
const [sb_nationality_id ,setSbNationalityId] =useState("")
const [sb_company_id , setSbCompanyId]= useState("")
const [address,setAdress]=useState("")
const [birthdate, setBirthDate]=useState("")
const [active,setActive]=useState(1)
const [access_system, setAcessSystem]=useState(1)
const [sb_shift_id, setSbShiftId]=useState("")
const [role, setRole]=useState("")
const [insurance_number, setInsuranceNumber]=useState("")
const [tax_number ,setTaxNumber]=useState("")
const [bank_name,setBankName]=useState("")
const [bank_swiftcode, setBankSwiftCode]=useState("")
const [bank_account_number, setBankAccountNumber]=useState("")
const [payroll_method, setPayrollMethod]=useState("cash")
const [image ,setImage]=useState("")
const [check_In_outside, setCheckInOutside]=useState(false)

 const mutation = useMutation("postEmployes" , (postData)=>postEmployes(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setNameAr("")
        setMobile("")
        setNationId("")
        setEmail("")
        setPassword("")
        setAdress("")
        setBirthDate("")
        setSbShiftId("")
        setRole("")
        setInsuranceNumber("")
        setTaxNumber("")
        setBankName("")
        setBankSwiftCode("")
        setBankAccountNumber("")

    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    } 
 })

 const handlePostRequest =()=>{
    const formData = new FormData()
    formData.append("name_ar", name_ar)
    formData.append("name_en", name_en)
    formData.append("mobile",mobile)
    formData.append("nation_id",nation_id)
    formData.append("email",email)
    formData.append("password",password)
    formData.append("sb_country_id",sb_country_id)
    formData.append("sb_city_id", sb_city_id)
    formData.append("sb_branch_id", sb_branch_id)
    formData.append("sb_department_id",sb_department_id)
    formData.append("sb_nationality_id" , sb_nationality_id)
    formData.append("sb_company_id",sb_company_id)
    formData.append("address" , address)
    formData.append("birthdate",birthdate)
    formData.append("active",active)
    formData.append("access_system",access_system)
    formData.append("sb_shift_id",sb_shift_id)
    formData.append("role" , role)
    formData.append("tax_number",tax_number)
    formData.append("insurance_number",insurance_number)
    formData.append("payroll_method",payroll_method)
    formData.append("bank_account_number",bank_account_number)
    formData.append("bank_swiftcode",bank_swiftcode)
    formData.append("fixable_check",check_In_outside)
    formData.append("bank_name",bank_name)
    formData.append("image",image)
    mutation.mutate(formData)
 }
 const isDisabled= ()=>{
    return !(name_ar && name_en &&  mobile,
        nation_id&&
        email&&
        password&&
        sb_country_id&&
        sb_city_id&&
        sb_branch_id&&
        sb_company_id&&
        sb_department_id&&
        sb_nationality_id&&
        address&&
        birthdate &&(role!=="system_adminstrator"&&role!=="adminstrator" &&(sb_branch_id&&sb_department_id&& sb_shift_id ) )&& (payroll_method !== "bank" || (bank_account_number && bank_swiftcode && bank_name)) )
 }
  return ( 

    <div>
        <PageHeader title="Add Employ" showBack={true}  saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddEmploy  check_In_outside={check_In_outside}  setCheckInOutside={setCheckInOutside} setImage={setImage}   tax_number={tax_number} insurance_number={insurance_number}  payroll_method={payroll_method} bank_account_number={bank_account_number} bank_swiftcode={bank_swiftcode}  bank_name={bank_name} setInsuranceNumber={setInsuranceNumber} setTaxNumber={setTaxNumber} setBankName={setBankName} setBankSwiftCode={setBankSwiftCode} setBankAccountNumber={setBankAccountNumber} setPayrollMethod={setPayrollMethod}   companyId={sb_company_id} departmentId={sb_department_id} branchId={sb_branch_id} countryId={sb_country_id}  name_ar={name_ar} name_en={name_en} active={active} role={role} address={address} birthdate={birthdate} access_system={access_system} email={email}  mobile={mobile} setActive={setActive} setCityId={setSbCityId} setCountryId={setSbCountryId} setCompanyId={setSbCompanyId}  setNameAr={setNameAr} setNameEn={setNameEn} setMobile={setMobile} setNationId={setNationId} setBranchId={setSbBranchId} setPassword={setPassword} setEmail={setEmail} setAdress={setAdress} setSbDepartmentId={setSbDepartmentId} setSbNationalityId={setSbNationalityId} setBirthDate={setBirthDate} setAcessSystem={setAcessSystem} setShiftId={setSbShiftId} setRole={setRole}/>
    </div>
  )
}

export default EmployesStore